<div class="d-flex align-items-center gap-1 flex-wrap">
  <ng-container *ngFor="let item of breadcrumbItems; let i = index">
    <!-- Clickable breadcrumb item -->
    <button 
      *ngIf="item.clickHandler && !item.isActive" 
      class="btn btn-link breadcrumb-item-box" 
      (click)="item.clickHandler()">
      <strong>{{ item.label }}</strong>
    </button>

    <!-- Non-clickable breadcrumb item -->
    <span 
      *ngIf="!item.clickHandler || item.isActive" 
      class="breadcrumb-item-box">
      <strong>{{ item.label }}</strong>
      <span *ngIf="item.count !== undefined" class="badge rounded-pill ms-1">{{ item.count }}</span>
    </span>

    <!-- Arrow separator (not for last item) -->
    <span *ngIf="i < breadcrumbItems.length - 1" class="arrow">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </span>
  </ng-container>
</div>